// import sensors from 'sa-sdk-javascript'
// import Vue from '../main'
// sensors.init({
//   show_log: false,
//   // server_url: 'http://samixinxi.datasink.sensorsdata.cn/sa?token=d1d73f8fe7cc92d3&project=default', // 测试
//   server_url: 'https://samixinxi.datasink.sensorsdata.cn/sa?token=d1d73f8fe7cc92d3&project=production', // 正式
//   is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
//   use_client_time: true,
//   send_type: 'beacon',
//   heatmap: {
//     // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
//     clickmap: 'default',
//     // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
//     scroll_notice_map: 'not_collect'
//   }
// })
// const pathReplace = () => {
//   return Vue.$route.meta.saName || ''
// }
// sensors.registerPage({
//   platform_type: 'H5',
//   is_login: () => {
//     return !!sessionStorage.getItem('access-token')
//   },
//   customer_type: () => {
//     let customerType = '普通用户'
//     const userType = sessionStorage.getItem('userType')
//     if (userType) {
//       const userTypeSplit = userType.split(',')
//       switch (userTypeSplit[0]) {
//         case '30': // 社团
//           customerType = '社团'
//           break
//         case '20': // 达人
//           customerType = '达人'
//           break
//         case '31': // 画手
//           customerType = '画手'
//           break
//         case '70': // 团长
//           customerType = '团长'
//           break
//         default: // 普通用户
//           customerType = '普通用户'
//           break
//       }
//     }
//     return customerType
//   },
//   channel_source: () => {
//     return ''
//   }
// })
// sensors.quick('autoTrack') // 用于采集 $pageview 事件。
// export default {
//   sensors: sensors,
//   setUser: (data) => {
//     console.log(parseInt(data.growVal))
//     let customerType = '普通用户'
//     const userType = data.userType
//     if (userType) {
//       const userTypeSplit = userType.split(',')
//       switch (userTypeSplit[0]) {
//         case '30': // 社团
//           customerType = '社团'
//           break
//         case '20': // 达人
//           customerType = '达人'
//           break
//         case '31': // 画手
//           customerType = '画手'
//           break
//         case '70': // 团长
//           customerType = '团长'
//           break
//         default: // 普通用户
//           customerType = '普通用户'
//           break
//       }
//     }
//     sensors.setProfile({
//       gender: !data.sex ? '' : data.sex === 1 ? '男' : '女',
//       birthday: data.birthday || '',
//       nick_name: data.nickname || '',
//       signup_time: data.createTime || '',
//       phone_number: data.phone || '',
//       microblog_account: data.weiboAccount || '',
//       email: data.email || '',
//       Point: parseInt(data.myPoint) || 0,
//       membership_level: parseInt(data.currentLevel.class) || 0,
//       m_coins: parseFloat(data.balance),
//       balance: parseFloat(data.miMoney),
//       customer_type: customerType,
//       Invitation_code: data.inviteCode || '',
//       growth_value: parseInt(data.growVal) || 0,
//       first_channel_source: '',
//       sami_id: parseInt(data.uuid)
//     }, () => {
//       console.log('设置用户表方法回调成功')
//     })
//     sensors.setOnceProfile({
//       signup_time: data.createTime
//     }, () => {
//       console.log('设置用户表注册时间方法回调成功')
//     })
//   },
//   sensorsLogin: (accountType, isSuccess, failReason) => {
//     sensors.track('Login', {
//       login_type: accountType,
//       is_success: isSuccess,
//       fail_reason: failReason
//     })
//   },
//   sensorsShare: (path) => {
//     sensors.track('Share_click', {
//       url_path: pathReplace() || path.split('.com')[1]
//     })
//   },
//   sensorsShareResult: (path, type, id, content) => {
//     sensors.track('Share_result', {
//       url_path: pathReplace() || path.split('.com')[1],
//       share_type: type,
//       content_id: id,
//       content_name: content,
//       share_channel: 'H5'
//     })
//   },
//   sensorsLike: (id, name, type, comment, isCancel) => {
//     sensors.track('Like', {
//       content_id: id,
//       content_name: name,
//       type: type,
//       url_path: pathReplace() || location.href.split('.com')[1],
//       is_sub_comment: comment,
//       is_cancel: isCancel
//     })
//   },
//   sensorsComment: (type, id, name, subComment) => {
//     sensors.track('Comment', {
//       type: type,
//       content_id: id,
//       content_name: name,
//       url_path: pathReplace() || location.href.split('.com')[1],
//       is_sub_comment: subComment
//     })
//   },
//   sensorsMiquanPost: (postId, postLabel, topicId, topicName) => {
//     sensors.track('Miquan_post', {
//       post_type: '拼贴',
//       post_id: postId,
//       post_label: postLabel,
//       topic_id: topicId,
//       topic_name: topicName
//     })
//   },
//   sensorsFollow: (id, isCancel) => {
//     sensors.track('Follow', {
//       follow_user_id: id,
//       url_path: pathReplace() || location.href.split('.com')[1],
//       is_cancel: isCancel
//     })
//   },
//   sensorsOrderCancellation: (orderId, orderAmount, orderActualAmount, discountId, discountType, discountName, discountAmount, ifUseDiscount) => {
//     sensors.track('Order_cancellation', {
//       order_id: orderId,
//       order_amount: orderAmount,
//       order_actual_amount: orderActualAmount,
//       discount_id: discountId,
//       discount_type: discountType,
//       discount_name: discountName,
//       discount_amount: discountAmount,
//       if_use_discount: ifUseDiscount
//     })
//   },
//   sensorsOrderCancellationDetail: (data) => {
//     sensors.track('Order_cancellation_detail', data)
//   },
//   sensorsNbClick: (menuId,menubarName,type,moduleNume) => {
//     sensors.track('navigation_bar', {
//       menu_id: menuId,
//       menu_name: menubarName,
//       module_name: moduleNume,
//       type: type
//     })
//   },
//   sensorsAdClick: (adId, adLocation, adSequence) => {
//     sensors.track('Ad_click', {
//       ad_id: adId,
//       ad_location: adLocation,
//       ad_sequence: adSequence + 1,
//       url_path: pathReplace() || location.href.split('.com')[1]
//     })
//   },
//   sensorsAddToCart: (data) => {
//     sensors.track('Add_to_cart', data)
//   },
//   sensorsSearchResult: (data) => {
//     sensors.track('Search_result', {
//       ...data,
//       url_path: pathReplace() || location.href.split('.com')[1]
//     })
//   },
//   sensorsCollectCommodity: (commodityId, commodityName, saleMode, associationId, associationName, isCancel) => {
//     sensors.track('Collect_commodity', {
//       commodity_id: commodityId,
//       commodity_name: commodityName,
//       sale_mode: saleMode,
//       association_id: associationId,
//       association_name: associationName,
//       is_cancel: isCancel
//     })
//   },
//   sensorsCouponAttain: (discountId, discountName, discountType, activityName) => {
//     sensors.track('Coupon_attain', {
//       discount_id: discountId,
//       discount_name: discountName,
//       discount_type: discountType,
//       activity_name: activityName,
//       url_path: pathReplace() || location.href.split('.com')[1]
//     })
//   },
//   sensorsDetailPageview: (type, contentId, contentName) => {
//     sensors.track('Detail_pageview', {
//       type: type,
//       content_id: contentId,
//       content_name: contentName,
//       url_path: pathReplace() || location.href.split('.com')[1]
//     })
//   }
// }
export default {
  sensors: {},
  setUser: (data) => {},
  sensorsLogin: (accountType, isSuccess, failReason) => {},
  sensorsShare: (path) => {},
  sensorsShareResult: (path, type, id, content) => {},
  sensorsLike: (id, name, type, comment, isCancel) => {},
  sensorsComment: (type, id, name, subComment) => {},
  sensorsMiquanPost: (postId, postLabel, topicId, topicName) => {},
  sensorsFollow: (id, isCancel) => {},
  sensorsOrderCancellation: (orderId, orderAmount, orderActualAmount, discountId, discountType, discountName, discountAmount, ifUseDiscount) => {},
  sensorsOrderCancellationDetail: (data) => {},
  sensorsNbClick: (menuId,menubarName,type,moduleNume) => {},
  sensorsAdClick: (adId, adLocation, adSequence) => {},
  sensorsAddToCart: (data) => {},
  sensorsSearchResult: (data) => {},
  sensorsCollectCommodity: (commodityId, commodityName, saleMode, associationId, associationName, isCancel) => {},
  sensorsCouponAttain: (discountId, discountName, discountType, activityName) => {},
  sensorsDetailPageview: (type, contentId, contentName) => {}
}



// WEBPACK FOOTER //
// ./src/utils/sensors.js